import React from 'react'

const AdminDashStats = ({ stats }) => {
  const markerColors = [
    "bg-emerald-500",
    "bg-blue-500",
    "bg-violet-500",
    "bg-rose-500"
  ];

  return (
    <div className="w-full bg-white rounded-2xl border border-slate-100 px-6 py-5"
      style={{ boxShadow: '0 1px 4px rgba(10,37,64,0.06)' }}
    >
      {/* Changed to lg:grid-cols-2 and adjusted the gaps/dividers for a 2x2 grid layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-6 divide-y lg:divide-y-0 divide-slate-100">
        {stats.map((group, index) => {
          const markerBg = markerColors[index % markerColors.length];

          return (
            <div
              key={group.category}
              className={`flex flex-col justify-start pt-4 lg:pt-0 first:pt-0 
                ${index % 2 !== 0 ? 'lg:pl-12 lg:border-l lg:border-slate-100' : ''} 
                ${index >= 2 ? 'lg:mt-2' : ''}`}
            >
              {/* Category Header */}
              <div className="flex items-center gap-2 mb-3">
                <div className={`w-1.5 h-1.5 rounded-full ${markerBg}`} />
                <h2 className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                  {group.category}
                </h2>
              </div>

              {/* Perfectly Aligned Key-Value Stack */}
              <div className="grid grid-cols-1 gap-y-2 w-full">
                {group.items.map((item, i) => (
                  <div key={i} className="grid grid-cols-[1fr_auto] items-center gap-4">
                    <span className="text-xs font-medium text-slate-500 truncate">
                      {item.title}
                    </span>
                    <span className="text-xs font-semibold text-slate-900 font-mono text-right">
                      {item.value?.toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default AdminDashStats